import {
    makeStyles,
    createStyles,
} from '@bb-ui/react-library/dist/components/styles';

// Matched to the UAS migration banner so the two read as the same component when a client
// sees both.
export const useStyles = makeStyles(
    () =>
        createStyles({
            banner: {
                marginBottom: '2%',
                minHeight: '62px',
                textAlign: 'left',
            },
            // The home page is a two column grid at md and up. Span both columns, the way
            // the welcome subtitle and every other full width block do, or the banner
            // renders half width with the title alongside it.
            homePageBanner: {
                gridColumn: '1 / -1',
            },
        }),
    {
        name: 'IncrementalAuthDeprecationBanner-',
    },
);
